// extracted by mini-css-extract-plugin
module.exports = {"VariantImageSelector":"styles_VariantImageSelector__ibL40","close":"styles_close___VN7Q","active":"styles_active__bCHn6","preOrderIcon":"styles_preOrderIcon__UYnHj"};